import styled from "styled-components";
import { COLORS, SEMI_BOLD_FONT_WEIGHT } from "@/react/theme/constants";

export const ObjectPropertyLabel = styled.div`
  font-weight: ${SEMI_BOLD_FONT_WEIGHT}; // Between "normal" and "bold"
  color: ${COLORS.secondary};
`;
